export default __webpack_public_path__ + "static/media/449.056b6117.jpg";